import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-player-eligibility-dialog-box',
  templateUrl: './player-eligibility-dialog-box.component.html',
  styleUrls: ['./player-eligibility-dialog-box.component.scss'],
})
export class PlayerEligibilityDialogBoxComponent implements OnInit {

  constructor(public appLinks: AppLinksService,
    public navParams: NavParams, private navigator: Navigator, public event:EventsService) { }

  private confirmBtnProgress: boolean = false;
  onConfirm() {
    if (!this.confirmBtnProgress) {
      this.confirmBtnProgress = true;
      this.event.publish('event:appInit:next')
      this.navigator.dismiss()
      this.confirmBtnProgress = false
    }
  }

  onDismiss = () => {
    let callBackFn = this.navParams.get('callBackFn');
    let myThis = this.navParams.get('myThis')
    this.navigator.dismiss()
    if (!!callBackFn) callBackFn(myThis);
  }

  goToFeatureSiteTermsLink() {
    this.appLinks.goToFeatureOfferTermsLink('terms');
    return false;
  }

  ngOnInit() { }

}
